import { inject, Injectable } from "@angular/core";
import { ModalOptions, NzModalService } from "ng-zorro-antd/modal";

@Injectable({
  providedIn: "root",
})
export class ModalService {
  nzModalService = inject(NzModalService);

  create(options: ModalOptions) {
    const modalRef = this.nzModalService.create({
      nzFooter: null,
      nzCentered: true,
      nzClosable: false,
      nzMaskClosable: false,
      nzData: {},
      nzAutofocus: null,
      nzStyle: {
        margin: 0,
        maxWidth: "95vw",
        maxHeight: "80vh",
        padding: 0,
      },
      nzWidth: 700,
      ...options,
    });
    return modalRef;
  }
}
